import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { briskBulkUploadPolicy } from "../../Service/girnarApi";
import React from "react";
import {
  Autocomplete,
  Drawer,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import { visuallyHidden } from "@mui/utils";
import BriskCreateCertificate from "./BriskCreateCertificate";
import { ToastError, ToastSuccess } from "../../UiComponents/Toaster/Toast";
import Loader from "../../UiComponents/Loader/Loader";
import { GetUser } from "../../Service/girnarApi";
import FloatLabel from "../../UiComponents/FloatLabel/FloatLabel";
import {
  CloseIcon,
  DownloadIcon,
  UploadIcon,
} from "../../Resources/Icons/icons";
import { CSVLink } from "react-csv";
import { DatePicker } from "antd";
import { FileUploader } from "react-drag-drop-files";
import dayjs from "dayjs";
const { RangePicker } = DatePicker;
const Last7Days = new Date();
Last7Days.setDate(Last7Days.getDate() - 7);
const TodayDate = new Date();

const BriskBulkUpload = (props) => {
  const [selectedUser, setSelecteduser] = React.useState("");
  const [userDetails, setUserDetails] = React.useState([]);
  const [openLoader, setOpenLoader] = React.useState(false);
  const [bulkUploadFile, setBulkUploadFile] = React.useState(null);
  const [resetFileKey, setResetFileKey] = React.useState(1);
  const UserType = sessionStorage.getItem("userType");

  const { setDrawerWidth, setOpenBulkUpload, getData, selectedStartDate } =
    props;

  React.useEffect(() => {
    GetUserDetails();
  }, []);

  // const openPolicyFile = (row) => {
  //   window.open(row.downloadUrl, "_blank");
  // };

  const uploadExcel = async () => {
    // console.log("csvLinkRef.current.link : ", ccEntryFile);
    if (!bulkUploadFile) {
      ToastError("Please upload Bulk policy excel data");
      return true;
    }
    let formData = new FormData();
    formData.append("createdBy", selectedUser);
    formData.append(bulkUploadFile, bulkUploadFile);
    setOpenLoader(true);
    await briskBulkUploadPolicy(formData)
      .then((res) => {
        if (res?.message) {
          ToastSuccess(res.message);
          setBulkUploadFile(null);
          setOpenBulkUpload(false);
          getData(selectedStartDate, dayjs(new Date()).endOf("day"));
        }
        // UniversalSearch(true);
      })
      .finally(() => {
        setOpenLoader(false);
      });
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/files/Brisk_BulkUpload_Template.xlsx"; // Path in the public folder
    link.download = "Brisk_BulkUpload_Template.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const GetUserDetails = () => {
    const bodyData = {
      requesttype: "TABLE",
      isAscending: true,
    };
    GetUser(bodyData)
      .then((res) => {
        const FilteredData = res.data
          .map((e) => {
            if (e.userType.includes("user")) {
              return {
                ...e,
                label: e.name + " - " + e.mobileNumber + " - " + e.email,
                value: e?._id,
              };
            } else {
              return null;
            }
          })
          .filter(Boolean);
        setUserDetails(FilteredData);
      })
      .catch((err) => ToastError("Network Error"));
  };

  return (
    <>
      <div className="MainRenderinContainer">
        <Grid container className="DrawerHeader" sx={{ padding: "10px" }}>
          <Grid item xs={10} sm={10}>
            <Typography>Bulk Upload - BRISK CPA RSA</Typography>
          </Grid>
          <Grid item xs={2} sm={2} className="d-flex justify-content-end">
            <CloseIcon
              onClick={() => {
                setDrawerWidth("25%");
                setOpenBulkUpload(false);
              }}
              sx={{ cursor: "pointer" }}
            />
          </Grid>
        </Grid>
      </div>
      <div className="container-fluid">
        <Grid container>
          <Grid item xs={12} sm={12}>
            <Grid container className="Master_Header_Container" spacing={1}>
              <Grid item sm={12} xs={12}>
                <FloatLabel label="Select User" value={selectedUser}>
                  <Autocomplete
                    className="AutoComplete_InputBox"
                    disablePortal
                    id="combo-box-demo"
                    options={userDetails}
                    onChange={(e, v) => setSelecteduser(v?._id)}
                    renderInput={(params) => <TextField {...params} />}
                    renderOption={(props, option) => (
                      <li {...props} key={option._id}>
                        {option.name +
                          " - " +
                          option.mobileNumber +
                          " - " +
                          option.email}
                      </li>
                    )}
                  />
                </FloatLabel>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Box
                  sx={{
                    height: "35px",
                    "& > label": { height: "100%" },
                    minWidth: "100px",
                  }}
                >
                  <FileUploader
                    handleChange={(e) => {
                      // console.log("e", e);
                      setBulkUploadFile(e);
                    }}
                    fileOrFiles={bulkUploadFile}
                    name="BulkUploadFile"
                    label="Upload Excel"
                    dropMessageStyle={{
                      color: "red",
                      border: "none",
                      borderRadius: "0px",
                    }}
                    types={["XLSX", "XLS"]}
                    key={resetFileKey}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Button
                  className="Master_Header_create_Button w-100"
                  endIcon={<UploadIcon />}
                  onClick={() => {
                    uploadExcel();
                  }}
                  sx={{ width: { xs: "100%", sm: "fit-content" } }}
                >
                  Import Data
                </Button>
              </Grid>
              <Grid item xs={12} sm={12} className="d-flex justify-content-end">
                <Button
                  className="Master_Header_create_Button w-100"
                  onClick={() => {
                    handleDownload();
                  }}
                  endIcon={<DownloadIcon />}
                  sx={{ width: { xs: "100%", sm: "fit-content" } }}
                >
                  Sample Data
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Loader open={openLoader} />
      </div>
    </>
  );
};

export default BriskBulkUpload;
